import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import type { DriverWorkContext } from '../api/apiService';
import { workContextLicenseLabel } from './workContextLabels';

export function WorkContextSummary({ context }: { context: DriverWorkContext }) {
  const { t } = useTranslation('workCompany');
  const company = context.open_session_context
    ? context.open_session_context.company_name
    : context.work_company?.name;
  const missingCompany = context.open_session_context
    ? t('historicalCompanyMissing', 'No company recorded for this open session')
    : t('unknownLicense', 'To confirm');
  const license = workContextLicenseLabel(context, t);
  return <View style={{ gap: 8 }}>
    <Text>{t('company', 'Company')}: {company || missingCompany}</Text>
    <Text>{t('license', 'License')}: {license}</Text>
    {context.pending_reason && <Text accessibilityRole="alert">
      {t('situation', 'Situation')}: {t(`pending.${context.pending_reason}`, 'Retry or contact support.')}
    </Text>}
  </View>;
}
